<div
	style="{{ rtspwebrtcVideoStyle }}"
	class="{{ rtspwebrtcVideoClass }}"
	(mouseenter)="fireOnMouseEnter()"
	(mouseleave)="fireOnMouseLeave()"
>
	<div style="width: 100%; height: 100%">
		<video
			#videoElement
			(canplay)="canPlay($event)"
			(playing)="playing($event)"
			autoplay
			style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; top: 0px; left: 0px"
			[muted]="true"
			[attr.poster]="settings.offlineVideoUrl"
		></video>

		@if (currentState === "Loading") {
			<img
				style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
				[src]="settings.waitingForVideoUrl"
			/>
		}

		@if (currentState === "Offline" || deviceStatus === ConnectivityState.Offline) {
			<img
				style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
				[src]="settings.offlineVideoUrl"
			/>
		}

		@if (rtspwebrtcProxyStatus === CameraProxyStatus.NoInput) {
			<img
				style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; position: absolute; top: 0px; left: 0px"
				[src]="settings.noVideoSignalUrl"
			/>
		}

		@if (settings.axisVideoPlayerEnableDebugWindow) {
			<div class="webrtc-video-player-debug-container">
				{{ sourceVideoOptions?.ipAddress }}
			</div>
		}
	</div>
</div>
